// Collection List View JavaScript

document.addEventListener("DOMContentLoaded", function () {
  // Image hover functionality
  const productImages = document.querySelectorAll(".product-image");

  productImages.forEach((image) => {
    const hoverImage = image.getAttribute("data-hover-image");
    const originalImage = image.src;

    if (hoverImage) {
      // Preload hover image
      const preloadImg = new Image();
      preloadImg.src = hoverImage;

      image.addEventListener("mouseenter", function () {
        image.src = hoverImage;
      });

      image.addEventListener("mouseleave", function () {
        image.src = originalImage;
      });
    }
  });

  const detectQuantityBtns = () => {
    // Quantity increase functionality
    const increaseButtons = document.querySelectorAll(
      ".quantity-button.increase"
    );
    increaseButtons.forEach((button) => {
      button.addEventListener("click", function () {
        const variantId = this.getAttribute("data-variant-id");
        const quantityDisplay = this.previousElementSibling;
        let currentQuantity = parseInt(quantityDisplay.textContent) || 0;

        // When quantity is 0, we need to add a new item to cart
        if (currentQuantity === 0) {
          addItemToCart(variantId, 1, quantityDisplay);
        } else {
          // Increase quantity by 1
          updateCartItemQuantity(
            variantId,
            currentQuantity + 1,
            quantityDisplay
          );
        }
      });
    });

    // Quantity decrease functionality
    const decreaseButtons = document.querySelectorAll(
      ".quantity-button.decrease"
    );

    decreaseButtons.forEach((button) => {
      button.addEventListener("click", function () {
        const variantId = this.getAttribute("data-variant-id");
        const quantityDisplay = this.nextElementSibling;
        let currentQuantity = parseInt(quantityDisplay.textContent) || 0;

        if (currentQuantity > 0) {
          // Decrease quantity by 1
          updateCartItemQuantity(
            variantId,
            currentQuantity - 1,
            quantityDisplay
          );
        }
      });
    });
  };

  detectQuantityBtns();
  window.detectQuantityBtns = detectQuantityBtns;

  // Function to add item to cart (when quantity is initially 0)
  function addItemToCart(variantId, quantity, quantityDisplay) {
    const productContainer = quantityDisplay.closest(".product-list-item");

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        // Update quantity display
        quantityDisplay.textContent = quantity;
        quantityDisplay.classList.add("active");

        // Activate indicator
        const indicator = productContainer.querySelector(".cart-indicator");
        if (indicator) {
          indicator.classList.add("active");
        }

        // Update Dawn theme cart
        updateDawnThemeCart();
      })
      .catch((error) => {
        console.error("Error adding item to cart:", error);
      });
  }

  // Function to update cart item quantity
  function updateCartItemQuantity(variantId, newQuantity, quantityDisplay) {
    const productContainer = quantityDisplay.closest(".product-list-item");

    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: newQuantity,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        // Find updated item quantity in the cart
        let updatedQuantity = 0;
        for (let i = 0; i < data.items.length; i++) {
          if (data.items[i].variant_id == variantId) {
            updatedQuantity = data.items[i].quantity;
            break;
          }
        }

        // Update quantity display
        quantityDisplay.textContent = updatedQuantity;

        // Toggle active class based on quantity
        if (updatedQuantity > 0) {
          quantityDisplay.classList.add("active");

          // Activate indicator
          const indicator = productContainer.querySelector(".cart-indicator");
          if (indicator) {
            indicator.classList.add("active");
          }
        } else {
          quantityDisplay.classList.remove("active");

          // Deactivate indicator
          const indicator = productContainer.querySelector(".cart-indicator");
          if (indicator) {
            indicator.classList.remove("active");
          }
        }

        // Update Dawn theme cart
        updateDawnThemeCart();
      })
      .catch((error) => {
        console.error("Error updating cart:", error);
      });
  }

  // Function to update Dawn theme cart
  function updateDawnThemeCart() {
    // Fetch the latest cart data
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        // Update cart count in header
        updateCartCount(cart);

        // Trigger Dawn's cart update if available
        triggerDawnCartUpdate(cart);
      })
      .catch((error) => {
        console.error("Error fetching cart:", error);
      });
  }

  // Update cart count in Dawn theme header
  function updateCartCount(cart) {
    // Update standard cart count elements
    const cartCountBubbles = document.querySelectorAll(".cart-count-bubble");
    const cartCountItems = document.querySelectorAll(".cart-count");

    if (cartCountBubbles.length > 0) {
      cartCountBubbles.forEach((bubble) => {
        // Check if there are items in the cart
        if (cart.item_count > 0) {
          // If bubble contains a span, update the span
          const span = bubble.querySelector("span");
          if (span) {
            span.textContent = cart.item_count;
          } else {
            bubble.textContent = cart.item_count;
          }
          bubble.classList.remove("hidden");
        } else {
          bubble.classList.add("hidden");
        }
      });
    }

    if (cartCountItems.length > 0) {
      cartCountItems.forEach((item) => {
        item.textContent = cart.item_count;
      });
    }
  }

  // Trigger Dawn theme's cart update mechanism
  function triggerDawnCartUpdate(cart) {
    // Try different methods to update Dawn's cart

    // Method 1: Check if Dawn has a cart update event
    if (typeof window.dispatchEvent === "function") {
      try {
        // Create and dispatch a custom event that Dawn might be listening for
        const updateEvent = new CustomEvent("cart:update", {
          detail: { cart: cart },
        });
        window.dispatchEvent(updateEvent);
      } catch (e) {
        console.error("Error dispatching cart update event:", e);
      }
    }

    // Method 2: Try to find and update Dawn's cart drawer if it exists
    const cartDrawer =
      document.getElementById("cart-notification") ||
      document.getElementById("cart-drawer") ||
      document.querySelector(".cart-notification");

    if (cartDrawer && typeof cartDrawer.refresh === "function") {
      try {
        cartDrawer.refresh();
      } catch (e) {
        console.error("Error refreshing cart drawer:", e);
      }
    }

    // Method 3: If Dawn uses sections API for cart updates, refresh cart section
    if (
      typeof window.Shopify !== "undefined" &&
      typeof window.Shopify.theme !== "undefined" &&
      typeof window.Shopify.theme.sections !== "undefined"
    ) {
      try {
        const sections = window.Shopify.theme.sections.registered || {};
        const cartSection = Object.values(sections).find(
          (section) =>
            section.type.includes("cart") ||
            section.type.includes("drawer") ||
            section.type.includes("mini-cart")
        );

        if (cartSection && typeof cartSection.onUnload === "function") {
          cartSection.onUnload();
          cartSection.onLoad();
        }
      } catch (e) {
        console.error("Error refreshing cart section:", e);
      }
    }
  }
});
